import apiSlice from './apiSlice';

export interface RollbackPayload {
  resultId: number; // send only these
}
export interface DeclareResultPayload {
  eventExternalId: string;
  marketId: string;
  selectionId: string;
  result: string;
  resultToShow?: string;
}

export const betResultApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // PENDING RESULT
    declareResult: builder.mutation<any, DeclareResultPayload>({
      query: (payload) => ({
        url: '/results/declare',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['PendingMarkets', 'RollbackMarkets', 'Stats'],
    }),

    // ROLLBACK RESULT
    rollbackResult: builder.mutation<any, RollbackPayload>({
      query: ({ resultId }) => ({
        url: `/results/${resultId}/change`,
        method: 'PATCH',
      }),
      invalidatesTags: ['RollbackMarkets', 'Stats'],
    }),
  }),
});

export const { useDeclareResultMutation, useRollbackResultMutation } = betResultApi;
